import * as React from 'react';
import { flow } from 'lodash';
import { withJob } from 'react-jobs';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { reset, destroy } from 'redux-form';
import { IStore } from '../../../../redux/IStore';
import Loading from '../../../../components/Loading';
import { Row, Button, Tabs, Tab } from 'react-bootstrap';
import { IAuthState } from '../../../../services/auth/models';
import { IChannel } from '../../../../data/api/models';
import { IQuoteActions } from '../../../../services/quote/models';
import { IBrandingActions } from '../../../../services/branding/models';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { actions as quoteActions } from '../../../../services/quote/reducer';
import { actions as brandingActions } from '../../../../services/branding/reducer';
import { actions as authActions, IAuthActions } from '../../../../services/auth/reducer';
import UpdateEmailModal from '../UpdateEmailModal';
import {isUndefined} from 'util';

interface IAccountSummaryProps {
  auth: IAuthState;
  actions: {
    auth: IAuthActions;
    quote: IQuoteActions;
    reset(formName: string);
    destroy(formName: string);
    branding: IBrandingActions,
    push: (route: string) => void;
    channel: IChannel;
  };
}

interface IAccountSummaryState {
  resize: boolean;
}

class AccountSummary extends React.Component<IAccountSummaryProps, IAccountSummaryState> {
  public state = {
    resize: false,
  };
  private renderPolicyLink = (cell, row) => {
    return (
      <div>
        <Link to={`/account/policies/${row.id}`} className={'policy-docs-link'}>
          View
        </Link>
      </div>
    );
  }

  private renderQuoteLink = (cell, row) => {
    return (
      <Link to={`/account/quotes/${row.id}`} className={'policy-docs-link'}>
        View quote
      </Link>
    );
  }

  private renderRenewalLink = (cell, row) => {
    return (
      <Link to={`/account/policies/${row.id}`} className={'policy-docs-link'}>
        View
    </Link>
    );
  }

  private renderInsuredDetails = (cell, row) => {
    if (!cell) {
      return null;
    }

    let content = <span>{cell.title} {cell.firstName} {cell.lastName}</span>;
    if (cell.firstName === 'Test' || cell.lastName === 'Test') {
      content = <span>-</span>;
    }
    if (cell.companyName) {
      content = <span>{cell.companyName}</span>;
    }

    return (
      content
    );
  }

  private renderStatus = (cell, row) => {
    const isDisplayPolicy = ! isUndefined(row.policyNumber);
    return (
      <Link to={`/account/` + (isDisplayPolicy ? 'policies' : 'quotes') + `/${row.id}`}>
        {row.status}
      </Link>
    );

  }

  private handleGetNewQuote = () => {
    const { actions } = this.props;

    actions.destroy('quote');
    actions.quote.reset();
    actions.push('/');
  }

  public componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  public resize() {
    this.setState({ resize: window.innerWidth <= 640 });
  }

  public render() {
    const { auth, actions, channel } = this.props;
    const defaultTab = auth.customer.policies.length > 0 ? 1 : 2;
    let width = '20%';
    let sort = true;
    let quoteTitle = 'Quote Reference';

    if (this.state.resize) {
      width = '25%';
      sort = false;
      quoteTitle = 'Quote Ref';
    }

    return (
      <Row className="page-container animated fadeIn">
        <div className="customer-section-title">
          <h4>Welcome {auth.customer.firstName !== 'Test' ? auth.customer.firstName : ''}</h4>
        </div>
        <Tabs defaultActiveKey={defaultTab} id="your-account-tabs" className="your-account-tabs">
          {auth.customer.policies.length > 0 && (
            <Tab eventKey={1} title="Policy(s)">
              <div className="white-section customer-table">
                <BootstrapTable
                  data={auth.customer.policies}
                  headerContainerClass="mobile-table-font"
                  trClassName="mobile-table-font"
                >
                  <TableHeaderColumn
                    dataField="policyNumber"
                    isKey={true}
                    width={width}
                    dataSort={sort}
                    className="mobile-header-view-padding"
                  >
                    Policy Number
                  </TableHeaderColumn>
                  {!this.state.resize && (
                    <TableHeaderColumn
                      dataField="insured"
                      width={width}
                      dataSort={sort}
                    >
                      Insured(s)
                    </TableHeaderColumn>
                  )}
                  <TableHeaderColumn
                    dataField="commencesAt"
                    width={width}
                    dataSort={sort}
                    className="mobile-header-view-padding"
                  >
                    Start Date
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="status"
                    width={width}
                    dataSort={true}
                    dataFormat={this.renderStatus}
                  >
                    Status
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width={width}
                    dataFormat={this.renderPolicyLink}
                  />
                </BootstrapTable>

                <div className="alert alert-default margin-top no-padding-left no-padding-right">
                  <p>
                    <strong>
                      If you have any queries or would like to make a change to your policy please call&nbsp;
                      {channel.baseName} on {channel.phone}
                    </strong>
                  </p>
                </div>
              </div>
            </Tab>
          )}

          {auth.customer.policyApplications.length > 0 && (
            <Tab eventKey={2} title="Quotes">
              <div className="white-section customer-table">
                <BootstrapTable
                  data={auth.customer.policyApplications}
                >
                  <TableHeaderColumn
                    dataField="quoteReference"
                    isKey={true}
                    width={width}
                    dataSort={sort}
                    className="mobile-header-view-padding"
                  >
                    {quoteTitle}
                  </TableHeaderColumn>
                  {!this.state.resize && (
                    <TableHeaderColumn
                      dataField="insured"
                      width={width}
                      dataSort={sort}
                      dataFormat={this.renderInsuredDetails}
                    >
                      Insured(s)
                    </TableHeaderColumn>
                  )}
                  <TableHeaderColumn
                    dataField="startDate"
                    width={width}
                    dataSort={sort}
                    className="mobile-header-view-padding"
                  >
                    Start Date
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    dataField="status"
                    width={width}
                    dataSort={true}
                    dataFormat={this.renderStatus}
                  >
                    Status
                  </TableHeaderColumn>
                  <TableHeaderColumn
                    width={width}
                    dataFormat={this.renderQuoteLink}
                  />
                </BootstrapTable>
              </div>
            </Tab>
          )}
        </Tabs>
        <div className="btn-bar policy-detail">
          <Button
            className={'btn-secondary'}
            type="submit"
            onClick={actions.auth.logout}
          >
            Log Out
          </Button>
          <Button
            className="btn-secondary continue-btn"
            onClick={this.handleGetNewQuote}
          >
            Get a new quote
          </Button>
          <UpdateEmailModal
            email={auth.customer.email}
            phone1={auth.customer.phone1}
          />
        </div>
      </Row>
    );
  }
}

export default flow([
  withJob({
    work: (props: IAccountSummaryProps) => {
      const promises = [];

      promises.push(props.actions.auth.reloadCustomer());

      return Promise.all(promises);
    },
    LoadingComponent: (props) => <Loading/>,
    ErrorComponent: ({ error }) => {
      console.error(error);

      return (
        <div>
          {error.message}
        </div>
      );
    },
  }),
  connect(
    (state: IStore) => {
      return {
        auth: state.auth,
        quote: state.quote,
        branding: state.branding,
        channel: state.branding.channel,
      };
    },
    (dispatch) => ({
      actions: {
        push: bindActionCreators(push, dispatch),
        reset: bindActionCreators(reset, dispatch),
        destroy: bindActionCreators(destroy, dispatch),
        auth: bindActionCreators({...authActions}, dispatch),
        quote: bindActionCreators({ ...quoteActions }, dispatch),
        branding: bindActionCreators({ ...brandingActions }, dispatch),
      },
    }),
  ),
])(AccountSummary);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/CustomerArea/scenes/AccountSummary/index.tsx